:host{position:absolute;top:0;left:0;width:100%;height:100%;z-index:9999;pointer-events:none}:host *{pointer-events:all}
/*# sourceMappingURL=tools.component-NNNVI75R.css.map */
